import { type TMycleContentMenu, type TMycleContentSeriesCode } from '../model'

const carStoryHomeKeys = {
  all: ['car-story-home'] as const,
}

const mycleContentsKeys = {
  all: ['mycle-contents'] as const,
  list: (
    menu: TMycleContentMenu,
    page: number,
    size: number,
    sort?: string,
    categoryId?: number
  ) =>
    [
      ...mycleContentsKeys.all,
      menu,
      page,
      size,
      sort ?? '',
      categoryId ?? '',
    ] as const,
  /** 인피니트 쿼리용 키 (page 제외 — pageParam으로 처리) */
  infinite: (
    menu: TMycleContentMenu,
    size: number,
    sort?: string,
    categoryId?: number
  ) =>
    [
      ...mycleContentsKeys.all,
      'infinite',
      menu,
      size,
      sort ?? '',
      categoryId ?? '',
    ] as const,
}

const mycleContentCategoriesKeys = {
  all: ['mycle-content-categories'] as const,
  list: (menu: TMycleContentMenu) =>
    [...mycleContentCategoriesKeys.all, menu] as const,
}

const mycleContentSeriesKeys = {
  all: ['mycle-content-series'] as const,
  list: (code: TMycleContentSeriesCode, page: number, size: number) =>
    [...mycleContentSeriesKeys.all, code, page, size] as const,
}

const mycleContentDetailKeys = {
  all: ['mycle-content-detail'] as const,
  detail: (contentId: number) =>
    [...mycleContentDetailKeys.all, contentId] as const,
}

const nearestPlacesKeys = {
  all: ['car-story-nearest-places'] as const,
  list: (latitude: number, longitude: number) =>
    [...nearestPlacesKeys.all, latitude, longitude] as const,
}

export const CAR_STORY_QUERY_KEYS = {
  HOME: carStoryHomeKeys,
  CONTENTS: mycleContentsKeys,
  CATEGORIES: mycleContentCategoriesKeys,
  SERIES: mycleContentSeriesKeys,
  DETAIL: mycleContentDetailKeys,
  NEAREST_PLACES: nearestPlacesKeys,
} as const
